<template>
  <div class="video-wrap">
    <i
      class="el-icon-video-play views"
      title="点击预览"
      @click="checkMedia(url, 'video', videoInfo)"
      v-if="url"
    >
    </i>
    <!--封面图、视频弹窗组件-->
    <preview-video ref="previewVideo"></preview-video>
  </div>
</template>
<script>
import PreviewVideo from "./preview-video";
export default {
  data() {
    return {};
  },
  components: {
    PreviewVideo,
  },
  props: ["url", "videoInfo"],
  methods: {
    // 查看媒体
    checkMedia(url, type, data) {
      this.$refs.previewVideo.open(url, type, data);
    },
  },
};
</script>

<style lang="scss" scoped></style>
